// extracted by mini-css-extract-plugin
export default {"header":"styles_header__x4Ucp","heading":"styles_heading__dLHNn","pageDescription":"styles_pageDescription__23uGd","mainContainer":"styles_mainContainer__lDuxy"};